import { combineReducers } from 'redux';
import punchlineCurriculumReducer from './reducers/punchlineCurriculumReducer';
import punchlineNavigationReducer from './reducers/punchlineNavigationReducer';
import punchlineSessionReducer from './reducers/punchlineSessionReducer';
import punchlineParticleReducer from './reducers/punchlineParticleReducer';

export default combineReducers({
  curriculum: punchlineCurriculumReducer,
  navigation: punchlineNavigationReducer,
  session: punchlineSessionReducer,
  particles: punchlineParticleReducer,
});
